module.exports = __webpack_public_path__ + "img/44_53.ffa61a77.png";